import axios from "axios";
import React, { useEffect, useState, useContext } from "react";
import { useSelector } from "react-redux";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SetUserSubscription } from "../../../Store/SubscriptionSlice";
import { useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { AppContext } from "../../../Context/Context";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import {
  PayPalScriptProvider,
  PayPalButtons,
  usePayPalScriptReducer,
} from "@paypal/react-paypal-js";

import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from "@mui/material/Box";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";

export default function RazorPay(props) {
  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);

  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value;
  const dispatchRedux = useDispatch();

  const [MonthlyPlanList, SetMonthlyPlanList] = useState([]);
  const [PlanInfo, SetPlanInfo] = useState([]);
  const [DomainCrawlsData, SetDomainCrawlsData] = useState([]);
  const [OppurtunitesData, SetOppurtunitesData] = useState([]);
  const [loading, Setloading] = useState(false);
  const [currentPlanInfo, SetCurrentPlanInfo] = useState([]);
  const [apiopen, setapiOpen] = React.useState(false);
  const [errApiIcon, setErrApiIcon] = useState(true);
  const [apierrorMsg, setapierrorMsg] = useState();

  const [PositionTrackingData, SetPositionTrackingData] = useState([]);
  const plandetails = useParams()
  const planid = plandetails.id;
  const GetPlanListing = async () => {
    Setloading(true);
    try {
      const Response = await axios.get(
        `${process.env.REACT_APP_API_URL}accounts/get_subscription_plan/?plan_id=${planid}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      );
      if (Response.data.plans) {
        console.log("kangnan",Response.data.plans[0]);
        SetPlanInfo(Response.data.plans[0]);
      }
    } catch (err) {
      console.log(err);
    }
    Setloading(false);
  };
  const GetuserList = async () => {
    Setloading(true);
    try {
      const Response = await axios.get(
        `${process.env.REACT_APP_API_URL}accounts/get_user_details/`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      );
      if (Response.data.user_subscription_data) {
        SetCurrentPlanInfo(Response?.data?.user_subscription_data?.subscription_plan_id);
      }
    } catch (err) {
      console.log(err);
    }
    Setloading(false);
  };
  useEffect(() => {
    GetPlanListing();
    GetuserList();
  }, []);

  const apihandleClose = () => {
    setapiOpen(false);
  };

 const handlePayment = async () => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}accounts/razorpay/create-subscription/`,
      { plan_id: planid, total_count: 1 },
      { headers: { Authorization: `${ApiToken}` } }
    );

    console.log("gnanesh", res?.data?.client_id);

    const options = {
      key: res?.data?.client_id,           // Razorpay key_id
      subscription_id: res?.data?.subscription_id,  
      name: "Your Company",
      description: "Your Plan",
      
      handler: async function (response) {
        try {
          const saveRes = await axios.post(
            `${process.env.REACT_APP_API_URL}accounts/razorpay/save-subscription/`,
            response, 
            {
              headers: { Authorization: ApiToken }
            }
          );

          console.log("Saved:", saveRes.data);
                    setapierrorMsg("Your subscription plan has been successfully processed.");
                setErrApiIcon(false);
                setapiOpen(true);
        } catch (err) {
          console.log("Save error:", err.response?.data);
                    console.log('chcek pay fail', err);
          const errorMsg =
            err?.message ||
            err?.details?.[0]?.description ||
            JSON.stringify(err) || "Payment has been failed. Please try again.";
          setapierrorMsg(errorMsg);
          setErrApiIcon(true);
          setapiOpen(true);
        }
      },

      theme: { color: "#3399cc" },

      modal: {
        ondismiss: function () {
          console.log("Payment popup closed");
        }
      }
    };

    const rzp = new window.Razorpay(options);
    rzp.open();

  } catch (error) {
    console.log("Payment Error:", error.response?.data || error);
          setapierrorMsg(error.response?.data?.details?error.response?.data?.details:"Try Again Some Time" );
          setErrApiIcon(true);
          setapiOpen(true);
  }
};

  return (
    <div className={`over_all_container ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />


      <Container maxWidth={false} sx={{ maxWidth: "1500px" }} style={{ marginTop: "30px", marginBottom: "30px" }}>
        <Box style={{ background: "#fff", borderRadius: "50px", padding: "0px 20px 0px 20px" }}>
          <Grid container style={{ display: "flex", alignItems: "center" }} >
            <Grid item xs={12} md={6}>
              <div><h1 className="dashboard_header">Plan Details</h1>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="top_breadcrumb_menu">
                <div className="exportpdf_outer">
                  <div style={{ display: "flex", justifyContent: "end" }}>
                    <CommonBreadCrumb breadcrumbValue={[
                      { title: 'Subscription', link: '/subscription' },
                      { title: 'Plan Details', activeColor: true }
                    ]} />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>


      {/* <div className="cnt_audit_outer_wrap">
        <div className="">
         
        </div>
        <div className="cnt_hdr_top_wraps">
          <div className="cnt_hdr_top_lft_wrap">
            <h2 className="heading_font">Plan Details</h2>
          </div>
        </div>
      </div> */}

      <div className="subscription_wrap">
        <div className="plans_list plan_detail_wrap">
          <div class="container" style={{ background: "none" }}>
            <div className="lists">

              <div className="first_row">
                <div>
                  <p class="type">{PlanInfo.subscription_name}</p>
                  <p>{PlanInfo.name}</p>
                  <p>{PlanInfo.description}</p>
                </div>

                {/* <p class="price">
                  {"$" + PlanInfo.monthly_amount_in_USD + "/" + PlanInfo.type}
                </p> */}


                <div className="plan_details_table_wrap">
                  <div>
                    <h1 className="title">Domains crawls and users</h1>
                    <table>
                      <thead>
                        <tr></tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>No Of Domains</td>
                          <td>{PlanInfo.domains_crawls_and_users?.no_of_domains}</td>
                        </tr>
                        <tr>
                          <td>No Of Campaigns</td>
                          <td>{PlanInfo.domains_crawls_and_users?.no_of_campaigns}</td>
                        </tr>
                        <tr>
                          <td>No Of Keywords</td>
                          <td>{PlanInfo.domains_crawls_and_users?.no_of_keywords}</td>
                        </tr>
                        <tr>
                          <td>Max No Of Web Pages For Crawl</td>
                          <td>{PlanInfo.domains_crawls_and_users?.max_no_of_web_pages_for_crawl}</td>
                        </tr>
                        <tr>
                          <td>Spell Check Urls</td>
                          <td>{PlanInfo.domains_crawls_and_users?.spell_check_urls}</td>
                        </tr>
                        <tr>
                          <td>No Of Competitors</td>
                          <td>{PlanInfo.domains_crawls_and_users?.no_of_competitors}</td>
                        </tr>
                      </tbody>
                    </table>

                  </div>

                  <div>
                    <h1 className="title">Opportunities And Backlinks</h1>
                    <table>
                      <tbody>
                        <tr>
                          <td>Missed Opportunities</td>
                          {PlanInfo?.opportunities_and_backlinks?.missed_opportunities == true ?
                            <td class="plan_yes">
                              <CheckCircleOutlineIcon />
                            </td> : <td className="plan_no">
                              <HighlightOffIcon />
                            </td>
                          }
                        </tr>
                        <tr>
                          <td>Backlinks Vs Competitors</td>
                          {PlanInfo?.opportunities_and_backlinks?.backlinks_vs_competitors == true ?
                            <td class="plan_yes">
                              <CheckCircleOutlineIcon />
                            </td> : <td className="plan_no">
                              <HighlightOffIcon />
                            </td>
                          }
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div>
                    <h1 className="title">Position Tracking</h1>
                    <table>
                      <thead>
                        <tr></tr>
                      </thead>
                      <table>
                        <thead>
                          <tr></tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Mobile Rank</td>
                            {PlanInfo?.position_tracking?.mobile_rank == true ?
                              <td class="plan_yes">
                                <CheckCircleOutlineIcon />
                              </td> : <td className="plan_no">
                                <HighlightOffIcon />
                              </td>
                            }
                          </tr>
                          <tr>
                            <td>Zeroth Rank</td>
                            {PlanInfo?.position_tracking?.zeroth_rank == true ?
                              <td class="plan_yes">
                                <CheckCircleOutlineIcon />
                              </td> : <td className="plan_no">
                                <HighlightOffIcon />
                              </td>
                            }
                          </tr>
                        </tbody>
                      </table>
                    </table>
                  </div>
                </div>
              </div>

              <div style={{ justifySelf: "center" }}>
                <button onClick={handlePayment} style={{
                  padding: "12px 14rem",
                  fontSize: "19px",
                  backgroundColor: "#068cdf",
                  color: "white",
                  borderRadius: "5px"
                }}>Pay with Razorpay</button>
              </div>

            </div>

          </div>
        </div>

      </div>
      <Container maxWidth={false} sx={{ maxWidth: "1500px" }} style={{ marginTop: "5px", marginBottom: "5px" }} >
        <Box style={{ padding: "0px 20px 0px 20px" }} >
          <Grid container style={{ display: "flex", alignItems: "center" }} >
            <Grid item xs={12} md={6}>
              <div><p style={{ color: "#000" }}>All Rights Reserved Copyright © 2026 | <span style={{ color: "#ff601f" }}> Elite site Optimizer</span></p></div>
            </Grid>
            <Grid item xs={12} md={6}>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <CommonErrorAlert
        data={{
          apiopen: apiopen,
          apiErrorMsg: apierrorMsg,
          isIconStyled: errApiIcon
        }}
        closeAlert={apihandleClose} />
    </div>


  );
}